import { View, Heading } from '@instructure/ui';
import useAppStore from '../../stores/app';
import ProctorsOnline from './Proctors';

const RoomOptions = () => {
  const { drawerWidth, room } = useAppStore();

  return (
    <>
      <View
        as="div"
        id="OptionsContainer"
        maxWidth={drawerWidth}
        minWidth={drawerWidth}
        margin="none auto"
        padding="small"
      >
        <ProctorsOnline />
      </View>
    </>
  );
};

export default RoomOptions;
